import { useMutation } from "@tanstack/react-query";
import { removeSet } from "api-client";

import { useAuthenticatedNavigationContext } from "src/layout/AuthenticatedNavigationContext";

import { useWorkoutEditStore } from "./WorkoutEditContext";

export function useRemoveSet() {
  const workoutEditStore = useWorkoutEditStore();
  const { startSaving } = useAuthenticatedNavigationContext();

  const mutation = useMutation({
    mutationFn: (setId: string) => {
      return removeSet({
        path: { workoutId: workoutEditStore.workout.id, setId },
      });
    },
  });

  function perform(workoutSetId: string) {
    if (mutation.isPending) {
      return;
    }

    const stop = startSaving();

    mutation.mutate(workoutSetId, {
      onSuccess: (response) => {
        const data = response.data.data;
        workoutEditStore.removeWorkoutSet(data.deletedWorkoutSet.id);
        stop();
      },
      onError: () => {
        stop("error");
      },
    });
  }

  return {
    mutation,
    perform,
  };
}
